var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"reminder-info"},[_vm._t("default"),_c('div',{staticClass:"reminder-btn",on:{"click":_vm.back}},[_vm._v(" 返回 ")])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }